/**
 * "just now", "12m", "3h", "yesterday", "Mon", "14 Sep", "14 Sep 2025".
 *
 * Short on purpose: it sits in a mono column beside an activity line and has
 * to be read at a glance, the way Linear's timestamps are.
 */
export function relativeTime(iso: string, now: Date = new Date()): string {
  const then = new Date(iso)
  const seconds = Math.round((now.getTime() - then.getTime()) / 1000)
  if (seconds < 45) return 'just now'
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24 && then.getDate() === now.getDate()) return `${hours}h ago`
  const yesterday = new Date(now)
  yesterday.setDate(now.getDate() - 1)
  if (sameDay(then, yesterday)) return 'yesterday'
  if (hours < 24 * 6) return then.toLocaleDateString('en-GB', { weekday: 'short' })
  const sameYear = then.getFullYear() === now.getFullYear()
  return then.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    ...(sameYear ? {} : { year: 'numeric' }),
  })
}

function sameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
  )
}
